jQuery( function( $ ) {

	function setCookie( cname, cvalue, exdays ) {
		const d = new Date();
		d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
		let expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}

	function getCookie( cname ) {
		let name = cname + '=';
		let decodedCookie = decodeURIComponent( document.cookie );
		let ca = decodedCookie.split( ';' );
		for ( let i = 0; i < ca.length; i++ ) {
			let c = ca[ i ];
			while ( c.charAt( 0 ) == ' ' ) {
				c = c.substring( 1 );
			}
			if ( c.indexOf( name ) == 0 ) {
				return c.substring( name.length, c.length );
			}
		}
		return '';
	}

	const currentUrl = new URL( window.location.href );
	const urlParams = new URLSearchParams( window.location.search );
	const cookie = getCookie( 'sparkoh-space-mission' );

	/**
	 * Space mission
	 */
	( function() {
		// Bail if this isn't the space-mission page
		if ( ! $( '.panel-specific-popups' ).length )
			return;

		let panelNumber = ( parseInt( urlParams.get( 'panel' ) ) || '' ) + ''; // Cast as int for sanitization then back into string

		let scannedPanels = [];

		// Get already scanned panels from cookies
		if ( cookie ) {
			scannedPanels = cookie.split( ',' );

			// Use last scanned panel if no panel number in url param
			if ( scannedPanels.length && ! panelNumber ) {
				panelNumber = scannedPanels[ scannedPanels.length - 1 ];
			}

		}

		// Bail if no panel number was found in url param or cookie
		if ( ! panelNumber ) {
			return;
		}

		const $panelSpecificPopup = $( '.panel-specific-popups > .wp-block-group:eq(' + ( panelNumber - 1 ) + ')' );

		// Bail if the panel popup for this panel number doesn't exist
		if ( ! $panelSpecificPopup.length )
			return;

		// Push this panel number to the list of scanned panels, unless it's already been scanned
		if ( ! scannedPanels.includes( panelNumber ) ) {
			scannedPanels.push( panelNumber );
			setCookie( 'sparkoh-space-mission', scannedPanels.join( ',' ), 365 );
		}

		// Make the planets active depending on how many panels have been scanned
		$( '.planets > .wp-block-group:lt(' + scannedPanels.length + ')' ).addClass( 'active' );

		if ( $panelSpecificPopup.hasClass( 'panel-empty-popup' ) ) // If the panel specific popup has this class -> display a simple "Success" popup
			$( '.success-popup' ).addClass( 'active' );
		else // Otherwise, display the "New message" popup
			$( '.new-message-popup' ).addClass( 'active' );

		// Close the "Success" popup when clicking the button inside it
		$( '.success-popup .wp-block-button a' ).on( 'click', function() {
			$( '.success-popup' ).removeClass( 'active' );

			// Display "Mission accomplished" message when enough panels have been scanned
			if ( scannedPanels.length >= 10 )
				$( '.mission-accomplished' ).addClass( 'active' );
		} );

		// Open the panel-specific popup when clicking the button inside the "New message" popup
		$( '.new-message-popup .wp-block-button a' ).on( 'click', function() {
			$( '.new-message-popup' ).removeClass( 'active' );
			$( '.panel-specific-popups, .panel-specific-popups > .wp-block-group:eq(' + ( panelNumber - 1 ) + ')' ).addClass( 'active' );

			// Add a button to close the panel specific popup
			const $popupCloseButton = $( '<div class="btn-close-popup"></div>' );
			$( '.panel-specific-popups' ).append( $popupCloseButton );
			$popupCloseButton.on( 'click', function() {
				$( '.panel-specific-popups, .panel-specific-popups > .wp-block-group.active' ).removeClass( 'active' );
			} );

			// Display "Mission accomplished" message when enough panels have been scanned
			if ( scannedPanels.length >= 10 )
				$( '.mission-accomplished' ).addClass( 'active' );
		} );
	} )();

	/**
	 * Certificate
	 */
	( function() {
		// Bail if this isn't the certificate page
		if ( ! $( '.certificate' ).length )
			return;

		// Redirect to homepage if the mission hasn't been accomplished (no cheating !)
		if ( ( ! urlParams.get( 'astronaut' ) || ! urlParams.get( 'rocket' ) ) && ( ! cookie || cookie.split( ',' ).length < 10 ) )
			window.location.href = currentUrl.origin;

		const name = urlParams.get( 'astronaut' );
		const rocket = parseInt( urlParams.get( 'rocket' ) );

		// Add selected class to selected rocket depending on url param, or select the first one by default
		if ( rocket && $( '.rockets > .wp-block-image:nth-child(' + rocket + ')' ).length ) {
			$( '.rockets > .wp-block-image:nth-child(' + rocket + ')' ).addClass( 'selected' );

			// Update a2a url
			$( '.a2a_kit' ).attr( 'data-a2a-url', currentUrl.toString() );
		}
		else {
			$( '.rockets > .wp-block-image:first-child' ).addClass( 'selected' );
			urlParams.set( 'rocket', 1 );
		}

		// Set name if astronaut url param exists
		if ( name ) {
			$( 'input[name="name"]' ).val( name );
			$( '.certificate-name' ).text( $( 'input[name="name"]' ).val() );

			$( '.a2a_kit' ).attr( 'data-a2a-url', currentUrl.toString() );
		}

		if ( rocket && name )
			$( 'body' ).addClass( 'certificate-is-prefilled' );

		// Add selected rocket to certificate
		$( '.certificate-rocket' ).html( $( '.rockets > .wp-block-image.selected' ).clone() );

		// Update name in certificate
		$( 'input[name="name"]' ).on( 'input', function() {
			$( '.certificate-name' ).text( $( this ).val() );

			// Update url param for sharing
			urlParams.set( 'astronaut', $( this ).val() );
			currentUrl.search = urlParams.toString();
			history.replaceState( {}, '', currentUrl.toString() );
			$( '.a2a_kit' ).attr( 'data-a2a-url', currentUrl.toString() );
		} );

		// Handle click on next rocket button
		$( '.rockets-next' ).on( 'click', function() {
			// Get next rocket
			let $nextRocket = $( '.rockets > .wp-block-image.selected' ).next();

			// If there's no next rocket, go back to the first one
			if ( ! $nextRocket.length )
				$nextRocket = $( '.rockets > .wp-block-image:first-child' )

			// Update selected class
			$( '.rockets > .wp-block-image' ).removeClass( 'selected' );
			$nextRocket.addClass( 'selected' );

			// Update the rocket displayed in the certificate
			$( '.certificate-rocket' ).html( $( '.rockets > .wp-block-image.selected' ).clone() );

			// Update url param for sharing
			urlParams.set( 'rocket', $( '.rockets > .wp-block-image.selected' ).index() + 1 );
			currentUrl.search = urlParams.toString();
			history.replaceState( {}, '', currentUrl.toString() );
			$( '.a2a_kit' ).attr( 'data-a2a-url', currentUrl.toString() );
		} );

		// Handle click on prev rocket button
		$( '.rockets-prev' ).on( 'click', function() {
			// Get prev rocket
			let $prevRocket = $( '.rockets > .wp-block-image.selected' ).prev();

			// If there's no prev rocket, go back to the last one
			if ( ! $prevRocket.length )
				$prevRocket = $( '.rockets > .wp-block-image:last-child' );

			// Update selected class
			$( '.rockets > .wp-block-image' ).removeClass( 'selected' );
			$prevRocket.addClass( 'selected' );

			// Update the rocket displayed in the certificate
			$( '.certificate-rocket' ).html( $( '.rockets > .wp-block-image.selected' ).clone() );

			// Update url param for sharing
			urlParams.set( 'rocket', $( '.rockets > .wp-block-image.selected' ).index() + 1 );
			currentUrl.search = urlParams.toString();
			history.replaceState( {}, '', currentUrl.toString() );
			$( '.a2a_kit' ).attr( 'data-a2a-url', currentUrl.toString() );
		} );

		// Handle click on print button
		$( '.btn-print' ).on( 'click', function() {
			window.print();
		} );

		// Handle click on reset button
		$( '.btn-reset-certificate' ).on( 'click', function() {
			// Reset name
			$( 'input[name="name"]' ).val( '' ).trigger( 'input' );

			// Reset rocket
			$( '.rockets > .wp-block-image' ).removeClass( 'selected' );
			$( '.rockets > .wp-block-image:first-child' ).addClass( 'selected' );

			// Update the rocket displayed in the certificate
			$( '.certificate-rocket' ).html( $( '.rockets > .wp-block-image.selected' ).clone() );

			// Reset url params
			urlParams.delete( 'rocket' );
			urlParams.delete( 'astronaut' );
			currentUrl.search = urlParams.toString();
			history.replaceState( {}, '', currentUrl.toString() );
			$( '.a2a_kit' ).attr( 'data-a2a-url', currentUrl.toString() );
		} );

		$( '.btn-download-certificate' ).on( 'click', function() {
			$( '.certificate > .certificate' ).css( 'box-shadow', 'none' );
			$( '.certificate > .certificate' ).css( 'min-width', '600px' );

			html2canvas( $( '.certificate > .certificate' ).get( 0 ), { scale: 2 } ).then( canvas => {
				let dataUrl = canvas.toDataURL( 'image/png' );

				let $a = $( '<a>', {
					href: dataUrl,
					download: 'brevet.png',
				} );

				$a.appendTo( 'body' ).get( 0 ).click();
				$a.remove();
			} );

			$( '.certificate > .certificate' ).css( 'box-shadow', '' );
			$( '.certificate > .certificate' ).css( 'min-width', '' );
		} );

		// Customize A2A email template
		if ( a2a_config ) {
			const lang = $( 'html' ).attr( 'lang' );

			if ( lang === 'en-US' )
				a2a_config.templates.email = {
					subject: "My astronaut certificate",
					body: "To view your certificate, click here :\n${link}",
				};
			else if ( lang === 'nl-NL' )
				a2a_config.templates.email = {
					subject: "Mijn astronautendiploma",
					body: "Klik hier om je diploma te bekijken :\n${link}",
				};
			else
				a2a_config.templates.email = {
					subject: "Mon diplôme d'astronaute",
					body: "Pour voir ton brevet, clique ici :\n${link}",
				};
		}
	} )();

	/**
	 * Language switcher
	 */
	$( '.wp-block-button[class*="lang-"]' ).on( 'click', function() {
		let lang = 'fr';

		if ( $( this ).hasClass( 'lang-nl' ) )
			lang = 'nl';
		else if ( $( this ).hasClass( 'lang-en' ) )
			lang = 'en';

		setCookie( 'current-lang', lang, 365 );
	} );

} );
